import React from "react";
import { useTranslation } from "react-i18next";
import { UseCases } from "@planzone/core";
import classNames from "classnames";
import { Identifiable, Status as S } from "@planzone/dto";

import { useTaskStatusCreation } from "@planzone/view-models";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { useModal } from "@root/client/modal";
import { Status } from "./status";
import { StatusCreationForm } from "./statusCreationForm";
import { AddIcon } from "./addIcon";
import styles from "./styles.scss";
import { Props } from "./types";

function Statuses({
  statuses,
  project,
  tasks,
  displayColorPickerCreation,
}: Props) {
  const { t } = useTranslation();
  const {
    isRequestPending: isTaskStatusCreationRequestPending,
    createTaskStatus,
  } = useTaskStatusCreation();
  const { pushView } = useModal();
  const findTasksWithStatus = (status: Identifiable<S>) =>
    tasks.filter((task) => task.status.uuid === status.uuid).length === 0;

  return (
    <div className={styles.statuses}>
      <div className={styles.section}>
        <p className={styles.title}>{t("projectTaskStatuses.activeStatus")}</p>
        <div className={styles.list}>
          {statuses
            .filter((elem) => elem.label !== "pr_done")
            .map((status) => (
              <Status
                status={status}
                deleteStatus={() => {
                  pushView({
                    data: {
                      status,
                      project,
                      hasNoTasks: findTasksWithStatus(status),
                    },
                    key: UseCases.removeTaskStatus,
                  });
                }}
                displayColorPickerCreation={displayColorPickerCreation}
              />
            ))}
        </div>
      </div>
      <div className={classNames(styles.section, styles.form)}>
        <VisibilityWatcher>
          {(isFormVisible, showForm, hideForm) => (
            <div className={styles.taskCreationWrapper}>
              {isFormVisible ? (
                <StatusCreationForm
                  submit={(status) => {
                    !isTaskStatusCreationRequestPending &&
                      createTaskStatus({ project, status });
                    hideForm();
                  }}
                  displayColorPickerCreation={displayColorPickerCreation}
                />
              ) : (
                <div
                  className={styles.addStatus}
                  onClick={(e) => {
                    e.stopPropagation();
                    showForm();
                  }}
                >
                  <AddIcon className={styles.icon} />
                  <p>{t("projectTaskStatuses.addStatus")}</p>
                </div>
              )}
            </div>
          )}
        </VisibilityWatcher>
      </div>
      <div className={styles.section}>
        <p className={styles.title}>{t("projectTaskStatuses.closeStatus")}</p>
        <div className={styles.list}>
          {statuses
            .filter((elem) => elem.label === "pr_done")
            .map((status) => (
              <Status
                status={status}
                displayColorPickerCreation={displayColorPickerCreation}
              />
            ))}
        </div>
      </div>
    </div>
  );
}

export { Statuses };
